import { Component, computed, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-custom-checkbox-dialog',
  imports: [
    MatDialogTitle,
    MatCheckbox,
    FormsModule,
    MatDialogClose,
    MatButton,
    MatDialogContent,
    MatDialogActions,
    TranslocoPipe
  ],
  templateUrl: './custom-checkbox-dialog.component.html',
  styleUrl: './custom-checkbox-dialog.component.scss'
})
export class CustomCheckboxDialogComponent {
  data = inject<{
    title: string;
    description: string;
    descriptionParameter: object;
    checkboxDescription: string;
    confirmButtonLable: string;
  }>(MAT_DIALOG_DATA);
  readonly translocoService = inject(TranslocoService);

  checkbox = false;

  title = '';
  description = '';
  descriptionParameter = {};
  checkboxDescription = '';
  confirmButtonLable = '';

  constructor() {
    const data = this.data;

    this.title = data.title;
    this.description = data.description;
    this.descriptionParameter = data.descriptionParameter;
    this.checkboxDescription = data.checkboxDescription;
    this.confirmButtonLable = data.confirmButtonLable;
  }

  getDescription = computed(() => {
    return this.translocoService.translate(this.description, this.descriptionParameter);
  });
}
